import { Component } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-distribution-performance',
  standalone: true,
  imports: [MaterialModule, TablerIconsModule],
  templateUrl: './distribution-performance.component.html',
})
export class DistributionPerformanceComponent {
  constructor() {}
}
